export const LABEL_FADE_MS = 300
